const Bold = (props) => {
    const { fontWeight = "bold", children } = props
    return <span style={{ fontWeight }}>{children}</span>
}

export default Bold
